// extracted by mini-css-extract-plugin
export default {"copyIcon":"clipboard-copy_copyIcon__IzGYS"};